<template>
  <iButton variant="text" :icon-color="iconColor" :style-overrides="wrapperStyleOverrides">
    <iRow
      :gap="gap"
      vertical-align="middle"
      width="hug"
      wrap="nowrap"
    >
      <iColumn v-if="prefix" width="hug">
        <iText v-bind="styleBindings" :style-overrides="styleBindings.textStyleOverrides">
          {{ prefix }}
        </iText>
      </iColumn>
      <iRow
        v-if="$slots.default"
        vertical-align="middle"
        :gap="gap"
        wrap="nowrap"
        width="hug"
      >
        <slot />
      </iRow>
      <iColumn v-if="suffix" width="hug">
        <iText v-bind="styleBindings" :style-overrides="styleBindings.textStyleOverrides">
          {{ suffix }}
        </iText>
      </iColumn>
    </iRow>
  </iButton>
</template>

<script>
import Enum from "@vcl";
import { themeStructure } from "@vcl";

export default {
  name: "PrefixSuffixWrapper",
  props: {
    prefix: {
      type: String,
      required: false,
      default: "",
    },
    suffix: {
      type: String,
      required: false,
      default: "",
    },
    styleBindings: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    gap: {
      type: [Number, Enum],
      required: false,
      default: "extraSmall",
      options: [...themeStructure.size.spacing],
    },
    iconColor: {
      type: String,
      required: false,
      default: "",
    },
    wrapperStyleOverrides: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
